import React, {useContext, useEffect} from 'react';
import AudioPlayer from './layout/AudioPlayer';
import Transcript from './layout/Transcript';
import Gallery from './layout/Gallery';
import {Settings} from '../store';

const BottomWidget = (props) => {

    const {activePointData, widgetRef, audioPlayStatus, setAudioPlayStatus, mapTop, currentStopNumber, activeRouteName, setFinalModal} = props;
    const {audioModal, transcriptModal, galleryModal} = useContext(Settings.State);

    const hasAudio = !!activePointData?.audio && (!audioModal || transcriptModal || galleryModal);
    const hasTranscript = !!activePointData?.text && !transcriptModal;
    const hasGallery = !!activePointData?.gallery?.length && !galleryModal;
    const visibleCount = [hasAudio, hasTranscript, hasGallery].filter(Boolean).length;

    const checkElementContent = () => {
        const element = document.getElementById('widget');
        if (element && !element.innerHTML.trim()) {
            element.style.display = 'none';
        } else {
            element.style.display = 'flex';
        }
    };

    useEffect(() => {
        checkElementContent();
    }, [activePointData]);

    return <div id="widget" ref={widgetRef} data-buttons={visibleCount}>
        {activePointData?.audio &&
            <AudioPlayer audioPlayStatus={audioPlayStatus} url={activePointData.audio.url} setFinalModal={setFinalModal}/>}
        {activePointData?.text &&
            <Transcript mapTop={mapTop} setAudioPlayStatus={setAudioPlayStatus} transcript={activePointData.text}/>}
        {activePointData?.gallery?.length > 0 &&
            <Gallery mapTop={mapTop} setAudioPlayStatus={setAudioPlayStatus}/>}
    </div>;
};

export default BottomWidget;